export default __webpack_public_path__ + "static/media/arrow-simple.ec04a748.svg";